class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderMiniCart() {
    $.getJSON('/cart.js', function(cart){
      if (cart['items'].length === 0) return;

      var outletLabelName = window.outletLabelName || 'מחיר עודפים';
      var outletLabelTag = '_label_' + outletLabelName;

      var tagFetches = cart['items'].map(function(item){
        return $.getJSON('/products/' + item.handle + '.js').then(function(p){
          return p && p.tags ? p.tags : [];
        }, function(){ return []; });
      });

      $.when.apply($, tagFetches).done(function(){
        var tagsByItem = cart['items'].length === 1 ? [arguments[0]] : Array.prototype.slice.call(arguments);
        var cart_list = [];

        for (var i = 0; i < cart['items'].length; i++) {
          var product_title = cart['items'][i]['product_title'];
          var line_price = cart['items'][i]['price']/100;
          var url = cart['items'][i]['url'];
          var image_url = cart['items'][i]['image'];
          var variants = cart['items'][i]['variant_options'];
          var key = cart['items'][i]['key'];
          var product_url = product_title == 'Gift Wrap' ? product_title : '<a href="' + url + '">' + product_title + '</a>';

          var options = [];
          for (var o = 0; o < variants.length; o++) {
            var selected = cart['items'][i]['variant_options'][o];
            if (selected !== 'Default Title') options.push(selected + ' ');
          }
          var selected_options = options.join('');

          var tags = tagsByItem[i] || [];
          var isOutlet = false;
          for (var t = 0; t < tags.length; t++) {
            if (String(tags[t]).toLowerCase() === 'outlet' || tags[t] === outletLabelTag) {
              isOutlet = true;
              break;
            }
          }
          var outletClass = isOutlet ? ' cartpopup-item--outlet' : '';
          var priceStyle = isOutlet ? ' style="color:#d72c2c"' : '';
          var outletPrefix = isOutlet ? ' <span class="cartpopup-item__outlet-label" style="color:#000">' + outletLabelName + ':</span>' : '';

          cart_list.push(
            '<div class="cartpopup-item d-flex flex-row' + outletClass + '">\
                <div class="cartpopup-item-image">\
                    <a href="' + url + '">\
                        <img class="img-fluid d-block" src="' + image_url + '"  alt="' + product_title + '" />\
                    </a>\
                </div>\
                <div class="cartpopup-item-content d-flex flex-column">\
                    <h5>' + product_url + '</h5>\
                    <span class="variant">' + selected_options + '</span>\
                    <span class="price"' + priceStyle + '>' + line_price + ' ש״ח ' + outletPrefix + '</span>\
                    <div class="d-flex flex-row">\
                        <a class="remove" href="/cart/change?id=' + key + '&amp;quantity=0">הסרה</a>\
                    </div>\
                </div>\
            </div>'
          );
        }
        cart_list.push(
          '<div class="cartpopup-footer d-flex flex-row">\
              <form action="/cart" method="post" id="cart-notification-form">\
                 <button class="button button--primary button--full-width" name="checkout">המשך למילוי פרטים ותשלום</button>\
              </form>\
              <button type="button" class="link button-label close-minicart">המשך רכישה</button>\
          </div>'
        );
        $('.mini-cart-products').html(cart_list.join(''));
        $('a#cart-icon-bubble').removeClass('closed').addClass('open');
        $("html, body").animate({ scrollTop: 0 }, "slow");
      });
    });
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      //this.open();
      this.renderMiniCart();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
